import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AlertClassColour, ConfigSystemParams, msSize } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-upload-centre-modal-form-search',
  templateUrl: './upload-centre-modal-form-search.component.html',
  styleUrls: ['./upload-centre-modal-form-search.component.scss']
})

export class UploadCentreModalFormSearchComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @Output() searchFormCancelled   : EventEmitter<boolean>=new EventEmitter<boolean>();
  @Output() searchFormHasBeenSaved: EventEmitter<void>   =new EventEmitter<void>   ();
  @Output() searchGridRowClick    : EventEmitter<number> =new EventEmitter<number> ();
  @Output() searchGridRowDblClick : EventEmitter<number> =new EventEmitter<number> ();

  @ViewChild('uploadModalFormSearch', { static: false }) searchFormModal! : TemplateRef<void>;
  @ViewChild('warningModalForm',      { static: false }) warningModalForm!: WarningModalFormComponent;
    
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
  
  private initialStatus      : string="Select a file to edit";
  private searchFormModalRef!: NgbModalRef;
  private selectedFileId     : number | undefined;
   
  public alertColourProgress : string=AlertClassColour.Green;
  public curUser             : SystemUserDTO;
  public formSubmitted       : boolean=false;
  public searchForm!         : UntypedFormGroup;
  public progressInformation : string=this.initialStatus;
  public submitButtonEnabled : boolean=false;
  public formTitle           : string="File Search";

  constructor(
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : UntypedFormBuilder,
    private lastPassKillerService: LastPassKillerService,
    private modalService         : NgbModal
  ) {
      this.curUser=this.authenticationService.currentUserObject();
  }
  
  public ngOnInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.alertColourProgress=AlertClassColour.Green;
      this.formSubmitted      =false;
      this.progressInformation=this.initialStatus;
      this.selectedFileId     =undefined;
      this.submitButtonEnabled=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(): void {
    try {
      this.resetMainVariables();
      this.setUpForm();
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.searchFormModalRef=this.modalService.open(this.searchFormModal, { backdrop: this.modalBackGround,
                                                                             centered: true,
                                                                             keyboard: false,
                                                                             size    : msSize.ExtraLarge });
    }
    catch(e) {
      this.searchFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region searchForm
  
  get formOfSearch() {
    return this.searchForm.controls;
  }
    
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private buildForm() {
    try {
      this.removeFormFields(this.searchForm);

       this.searchForm=this.formBuilder.group({ });
      
      this.addFormFields(this.searchForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.searchForm) {
        // this.addFormControl(formGroup, "newFile", false, []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.searchForm) {
        
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public searchFormSubmit() {
    try {
      this.formSubmitted=true;
      
      if (this.searchForm.valid) {
        if (this.selectedFileId) {
          this.searchGridRowClick.emit(this.selectedFileId);
          this.searchFormHasBeenSaved.emit();
          this.searchFormModalRef.close();

        } else {
          this.warningModalForm.openForm("Select a File", "to edit", "https://cdn.lordicon.com/fjvfsqea.json");
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public searchFormCancel() {
    try {
      this.searchFormCancelled.emit();
      this.searchFormModalRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public gridRowClick(rowId: number){
    try {
      this.selectedFileId=rowId;
      
      this.searchGridRowClick.emit(this.selectedFileId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public gridRowDblClick(rowId: number){
    try {
      this.selectedFileId=rowId;

      this.searchGridRowClick.emit(this.selectedFileId);
      this.searchFormModalRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
}
